import { DebugManager } from "../jsx/DebugManager"

export function getEntitiesUrlParameters(listPagination, listFilters, listOrders) {
  let dMgr = new DebugManager("getEntitiesUrlParameters")
  // dMgr.activate(true)
  let debug = dMgr.debug
  debug("listPagination:", listPagination)
  debug("listFilters:", listFilters)
  debug("listOrders:", listOrders)

  let parameters = {
    itemsPerPage: listPagination.itemsPerPage,
    page: listPagination.page,
  }

  Object.keys(listFilters).forEach((filterName) => {
    let filterValue = listFilters[filterName]
    switch (filterName) {
      case "searchStrings":
        if (filterValue !== "") {
          parameters[filterName] = filterValue.split(" ")
        }
        break
      case "isVisible":
        if (filterValue) {
          parameters[filterName] = filterValue
        }
        break
      case "isWashable":
        if (filterValue !== "") {
          parameters[filterName] = filterValue
        }
        break
      default:
        parameters[filterName] = filterValue
    }
  })

  if (Object.keys(listOrders).length > 0) {
    parameters["order"] = listOrders
  }

  debug("parameters:", parameters)
  return parameters
}
